// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__-5mu7","logo":"Logo_logo__vDBPO"};